export function downloadFromUrl(url: string, fileName?: string): void {
    // A programmatic anchor click is treated as a user-initiated download, so it isn't subject to
    // the popup blocking that can silently swallow a `window.open` fired after an awaited request.
    const a = document.createElement('a');
    a.href = url;
    if (fileName) {
        a.download = fileName;
    }
    a.rel = 'noopener';

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export function downloadBlob(blob: Blob, fileName: string): void {
    // Create a URL for the blob
    const url = URL.createObjectURL(blob);

    // Create a temporary anchor element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;

    // Append anchor to body, trigger click, and remove it
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Clean up by revoking the blob URL
    URL.revokeObjectURL(url);
}
